<template>
  <div id="CompanyDialog">
    <el-dialog
      title="单位"
      width="922px"
      append-to-body
      :visible.sync="visible"
      @close="clearData"
      :show="show"
    >
      <div
        class="CompanyDialog_one"
        ref="key_content"
        id="key_content"
        tabindex="1"
        @keydown.up="upkey($event)"
        @keydown.down="downkey($event)"
        @keydown.enter="enterkey($event)"
      >
        <div class="CompanyDialog_inputMust_text">
          <div style="display: flex; margin-bottom: 4px;">
            <el-input
              ref="input"
              v-model="searchText"
              size="mini"
              placeholder="输入名称/编号/助记码"
              class="search_input"
              @keydown.up.native="upkey($event)"
              @keydown.down.native="downkey($event)"
              @keydown.enter.native="enterkey($event)"
            ></el-input>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="communicationkeyupCompany"
            >查询</el-button>
          </div>
          <div>
            <vxe-table
              ref="xTable"
              class="right"
              size="small"
              border
              highlight-hover-row
              highlight-current-row
              :keyboard-config="{isArrow:true}"
              :auto-resize="true"
              height="400px"
              :data="tableData"
              show-overflow
              show-header-overflow
              @select-change="selectChangeEvent"
              @select-all="selectAllEvent"
              @cell-dblclick="dbclick"
            >
              <!-- <vxe-table-column type="checkbox" align="center" fixed="left" width="60"></vxe-table-column> -->
              <vxe-table-column width="50" fixed="left" title="类型" align="center">
                <template v-slot="{row}">
                  <i
                    :class="row.IsDir?'el-icon-folder':'el-icon-tickets'"
                    style="color:#e9cb70;font-size:18px"
                  ></i>
                </template>
              </vxe-table-column>
              <template v-for="(item,index) in tableHeadData">
                <vxe-table-column
                  :field="item.Key"
                  :title="item.Label"
                  width="150"
                  align="center"
                  fixed="left"
                  v-if="item.Key=='FullName'"
                  :key="index"
                ></vxe-table-column>
                <vxe-table-column
                  :field="item.Key"
                  :title="item.Label"
                  align="center"
                  v-else-if="item.Key=='BaseCode'"
                  :key="index"
                ></vxe-table-column>
                <vxe-table-column
                  :field="item.Key"
                  :title="item.Label"
                  align="center"
                  v-else
                  :key="index"
                ></vxe-table-column>
              </template>
            </vxe-table>
          </div>
          <div class="content_btn_box">
            <el-pagination
              style="display: flex;  justify-content: space-between;justify-content: center; "
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20,50,100]"
              :page-size="pagesize"
              layout="total, sizes,prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
            <div style="width: 214px;display: flex;justify-content: flex-end;">
              <el-button type="primary" size="mini" style="display:block" @click="saveGoods">确定</el-button>
              <el-button style="display:block" size="mini" @click="$emit('update:show', false)">取消</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tool from "@/utils/tool";
export default {
  data() {
    return {
      currentPage: 1, //当前页码
      total: 0, //总页数
      pagesize: 10, //每页显示数量
      tableData: [],
      multipleSelection: [], //多选
      searchText: "", // 查询条件
      placeholder: "", // 提示消息
      rowIndex: 0, //默认表格索引
      tableHeadData: this.configData, //表格表头配置字段
      visible: this.show //是否显示选择弹出框
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    configData: {
      type: Array,
      default: () => {
        return [
          { Label: "单位名称", Key: "FullName" },
          { Label: "单位编号", Key: "BaseCode" },
          { Label: "助记码", Key: "PyNo" },
          { Label: "备注", Key: "Mame" },
          { Label: "状态", Key: "StopedName" }
        ];
      }
    } //配置项数据
  },
  mounted() {},
  methods: {
    saveGoods() {},
    handleSizeChange() {},
    handleCurrentChange() {},
    /* 单位 */
    pagingfunctionCompany() {
      let params = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        pagesize: this.pagesize, //每页显示数量
        pagenum: this.currentPage, //当前页码
        type: 0,
        Stoped: 0
      };
      let jparams = JSON.stringify(params);
      let jparams_paging = { jparams: jparams };
      this.request
        .post("index/Settings/get_other", jparams_paging)
        .then(res => {
          let { status, description, data, count } = res;
          if (status == 0) {
            this.tableData = data;
            this.total = count;
          }
        });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.pagingfunctionCompany();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.pagingfunctionCompany();
    },
    // 双几行
    dbclick(row) {
      let _this = this;
      setTimeout(() => {
        _this.$emit("chooseBack", [row.row]);
        _this.$emit("update:show", false);
      }, 100);
    },
    // 多选
    selectAllEvent({ selection }) {
      this.multipleSelection = selection;
    },
    selectChangeEvent({ selection }) {
      this.multipleSelection = selection;
    },
    // 按上键
    upkey(e) {
      // if (this.rowIndex != 0) {
      //   this.rowIndex--;
      // }
      // this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
      // this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
    },
    // 按下键
    downkey(e) {
      // let that = this;
      // if (this.tableData && this.rowIndex + 1 < this.tableData.length) {
      //   this.rowIndex++;
      // }
      // that.$nextTick(() => {
      //   that.$refs.xTable.setCurrentRow(that.tableData[that.rowIndex]);
      //   that.$refs.xTable.scrollToRow(that.$refs.xTable.getCurrentRow());
      // });
    },
    // 按回车键
    enterkey(e) {
      // this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
      // if (this.multipleSelection.length !== 0) {
      //   this.$nextTick(() => {
      //     let _this = this;
      //     setTimeout(() => {
      //       let a = Date.parse(new Date());
      //       _this.$refs.xTable.getCurrentRow()._XID = `row_${a}`;
      //       _this.$emit("chooseBack", this.multipleSelection);
      //       _this.$emit("update:show", false);
      //     }, 100);
      //   });
      // } else {
      //   this.$nextTick(() => {
      //     let _this = this;
      //     setTimeout(() => {
      //       let a = Date.parse(new Date());
      //       _this.$refs.xTable.getCurrentRow()._XID = `row_${a}`;
      //       _this.$emit("chooseBack", [_this.$refs.xTable.getCurrentRow()]);
      //       _this.$emit("update:show", false);
      //     }, 100);
      //   });
      // }
    },
    // 查询条件
    communicationkeyupCompany() {},
    // 退出清除数据
    clearData() {
      // 退出前是数据初始化
      this.$emit("update:show", false);
    }
  },
  created() {},
  watch: {
    show() {
      this.visible = this.show;
      if (this.visible) {
        this.pagingfunctionCompany();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.CompanyDialog_one {
  height: 458px;
}
.content_btn_box {
  margin-top: 4px;
  display: flex;
  justify-content: space-between;
  position: relative;
  -webkit-box-align: center;
  box-align: center;
}
.search_input {
  display: block;
  width: 202px;
  margin-right: 8px;
}
.el-button--small,
.el-button--small.is-round {
  padding: 4px 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/CompanyDialog/CompanyDialog.vue